import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import React, { useCallback, useEffect, useRef } from 'react';
import moveNode from './moveNode';

export default function Tree({ children, nodes, onDrop, onMove }) {
  const ref = useRef();

  const handleDrop = useCallback(
    (args) => {
      if (typeof onDrop === 'function') onDrop(args);
      if (typeof onMove === 'function') {
        const updated = moveNode({ nodes, ...args });
        onMove(updated);
      }
    },
    [nodes, onDrop, onMove],
  );

  useEffect(() => {
    return combine(
      monitorForElements({
        element: ref.current,
        onDrop: handleDrop,
      }),
    );
  }, [handleDrop]);

  return <div ref={ref}>{children}</div>;
}
